import { Entity, JoinTable, ManyToMany, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import Pedido from './Pedido';
import Produto from './Produto';
import ProdutoNoPedido from './ProdutoNoPedido';

@Entity()
export class ProdutoCompostoNoPedido {
  @PrimaryGeneratedColumn()
  id!: number;

  @ManyToMany(() => Produto, { eager: true })
  @JoinTable({ name: 'produto_composto_tem_produto' })
  produtos!: ProdutoNoPedido[];

  @ManyToOne(() => Pedido)
  pedido!: Pedido;
}

export default ProdutoCompostoNoPedido;
